module.exports = __webpack_public_path__ + "assets/2bf35a342fcd6642b47011ed06c9fecd.png";